import * as z from 'zod';

export const VentilationSchema = z.object({
  system: z.string().optional(),
  isVariableAirVolumeSystem: z.boolean().optional(),
  hasCO2Sensors: z.boolean().optional(), // related to the previous
  hasParkadeCOSensors: z.boolean().optional(), // related to parkade and exhaust fans
});

export type Ventilation = z.infer<typeof VentilationSchema>;
